import { createApp } from 'vue'
import App from 'App.vue'
import axios from 'axios'
import store from 'store'
import { languages, defaultLocale, fallbackLocale} from 'lang'
import { createI18n, useI18n } from 'vue-i18n'
import VueCookies from 'vue3-cookies'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import 'assets/stylesheets/main.scss'
import 'extends';
import VueYandexMetrika from 'vue3-yandex-metrika'
import router from 'router'
import Toast from "vue-toastification"
import { printDebugConsole } from '@/helpers/debug';

library.add(fas)

const messages = Object.assign(languages)
const i18n = createI18n({
    locale: defaultLocale,
    fallbackLocale: fallbackLocale,
    globalInjection: true,
    legacy: false,
    messages
})

axios.defaults.timeout = 60000;
axios.defaults.withCredentials = true;
axios.defaults.withXSRFToken = true;

axios.interceptors.response.use(
    response => {
        // Print debug info in console
        if (response.data && response.data._debug) {
            printDebugConsole(response);
        }

        return response;
    },
    error => Promise.reject(error),
);

const app = createApp(App, {
    setup() {
        const {t} = useI18n()
        return {t}
    }
})

app.config.globalProperties.$axios = axios

app.component('font-awesome-icon', FontAwesomeIcon)
app.use(store)
app.use(i18n)
app.use(VueCookies)
app.use(router)
const yaMetrikaKey = process.env.VUE_APP_YAMETRIKA_KEY;
if(yaMetrikaKey){
    app.use(VueYandexMetrika, {
        id: yaMetrikaKey,
        router: router,
        env: process.env.NODE_ENV
   })
}
app.use(Toast, {
    timeout: 10000,
    position: 'bottom-right',
    transition: "Vue-Toastification__bounce",
    maxToasts: 5,
    closeOnClick: true,
    pauseOnFocusLoss: true,
    pauseOnHover: false,
    draggable: true,
    draggablePercent: 0.7,
    showCloseButtonOnHover: false,
    closeButton: "button",
    icon: true,
    rtl: false,
})

app.mount('#app')
